const host = "https://res.hotelkey.com";
const app_path = "/res/mvc.php/web_menus_tool";

// /res/mvc.php/web_menus_tool/menus
const getHomePath = function () {
    return app_path + "/app";
}

// /res/mvc.php/web_menus_tool/editMenu/9
const getEditMenuPath = function (menu_id) {
    return app_path + "/editMenu/" + menu_id;
}

// /res/mvc.php/web_menus_tool/listMenuItems/9
const getlistMenuItemsPath = function (menu_id) {
    return app_path + "/listMenuItems/" + menu_id;
}

// /res/mvc.php/web_menus_tool/addMenuItem/9
const addMenuItemPath = function (menu_id) {
    return app_path + "/addMenuItem/" + menu_id;
}

// /res/mvc.php/web_menus_tool/editMenuItem/1/9
const getEditMenuItemPath = function (menu_id, item_id) {
    return app_path + "/editMenuItem/" + menu_id + "/" + item_id;
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/menus
const getMenusListUrl = function () {
    return host + app_path + "/menus";
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/menuItems
const getMenuItemsListUrl = function () {
    return host + app_path + "/menuItems";
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/menu
const getMenuUrl = function () {
    return host + app_path + "/menu";
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/menuItem
const getMenuItemUrl = function () {
    return host + app_path + "/menuItem";
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/menuItemsPosition
const getMenuItemsPositionUrl = function () {
    return host + app_path + "/menuItemsPosition";
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/menuDraft
const getMenuDraftUrl = function () {
    return host + app_path + "/menuDraft";
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/env
const getEnvironmentUrl = function () {
    return host + app_path + "/env";
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/countries
const getCountriesUrl = function () {
    return host + app_path + "/countries";
}

// https://res.destinia.com/web_menu/test?menu=XXXX
const getTestMenuUrl = function (menu_id) {
    return "https://res.destinia.com/web_menu/test?menu=" + menu_id;
}

// https://res.destinia.com/web_menu/aura_test?menu=XXXX

const getAuraTestMenuUrl = function (menu_id) {
    return "https://res.destinia.com/web_menu/aura_test?menu=" + menu_id;
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/duplicateMenuItem
const getDuplicateMenuItemUrl = function () {
    return host + app_path + "/duplicateMenuItem";
}

// https://res.hotelkey.com/res/mvc.php/web_menus_tool/label?id=3370&lang=es
const getLabelUrl = function(id, lang) {
    return host + app_path + "/label?id=" + id + "&lang=" + lang;
}

export default {
    getMenusListUrl,
    getMenuUrl,
    getMenuItemUrl,
    getEnvironmentUrl,
    getCountriesUrl,
    getMenuItemsPositionUrl,
    getHomePath,
    getEditMenuPath,
    getEditMenuItemPath,
    getlistMenuItemsPath,
    addMenuItemPath,
    getTestMenuUrl,
    getAuraTestMenuUrl,
    getMenuDraftUrl,
    getDuplicateMenuItemUrl,
    getMenuItemsListUrl,
    getLabelUrl
};
